import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { EPlayerRole } from "cresus-common";
import PlayerLoginPage from "../pages/PlayerLoginPage";
import AnimatorLoginPage from "../pages/AnimatorLoginPage";
import FunctionalButton from "../components/FunctionalButton";
import AuthContext from "./AuthContext";
import { useBoardGame } from "./BoardGameProvider";
//TODO work on this to fix lot of issues
const AuthContextProvider = ({ children }) => {
    const { playSound } = useBoardGame();
    // --------------------------------------------------------
    // STEP 1: Parse session info synchronously
    // --------------------------------------------------------
    const params = new URLSearchParams(window.location.search);
    let sessionIdStr = params.get("sessionId") || sessionStorage.getItem("sessionId");
    if (sessionIdStr)
        sessionStorage.setItem("sessionId", sessionIdStr);
    const sessionId = sessionIdStr ? parseInt(sessionIdStr) : null;
    const isAnimator = params.get("isAnimator") === "true" ||
        sessionStorage.getItem("isAnimator") === "true";
    const isCoAnimator = params.get("isCoAnimator") === "true" ||
        sessionStorage.getItem("isCoAnimator") === "true";
    sessionStorage.setItem("isAnimator", isAnimator ? "true" : "false");
    sessionStorage.setItem("isCoAnimator", isCoAnimator ? "true" : "false");
    // --------------------------------------------------------
    // STEP 2: Restore auth state from sessionStorage
    // --------------------------------------------------------
    const [isLogged, setIsLogged] = useState(sessionStorage.getItem("isLogged") === "true" || false);
    const [token, setToken] = useState(sessionStorage.getItem("token") || null);
    const [role, setRole] = useState(() => {
        const savedRole = sessionStorage.getItem("role");
        if (savedRole === "ANIMATOR")
            return EPlayerRole.ANIMATOR;
        if (savedRole === "PLAYER")
            return EPlayerRole.PLAYER;
        return isAnimator || isCoAnimator
            ? EPlayerRole.ANIMATOR
            : EPlayerRole.PLAYER;
    });
    const [authenticatedName, setAuthenticatedName] = useState(sessionStorage.getItem("authenticatedName") || undefined);
    // --------------------------------------------------------
    // STEP 3: Normalize URL (safe, no reload)
    // --------------------------------------------------------
    useEffect(() => {
        if (!sessionId)
            return;
        const url = new URL(window.location.href);
        url.searchParams.set("sessionId", sessionId.toString());
        if (isAnimator) {
            url.searchParams.set("isAnimator", "true");
            url.searchParams.delete("isCoAnimator");
        }
        else if (isCoAnimator) {
            url.searchParams.set("isCoAnimator", "true");
            url.searchParams.delete("isAnimator");
        }
        else {
            url.searchParams.delete("isAnimator");
            url.searchParams.delete("isCoAnimator");
        }
        window.history.replaceState(null, "", url.toString());
    }, [sessionId, isAnimator, isCoAnimator]);
    // --------------------------------------------------------
    // STEP 4: Handle Login / Logout
    // --------------------------------------------------------
    function handleLogin(code, playerRole, name) {
        playSound("GlobalAmbiance");
        setToken(code);
        setRole(playerRole);
        setIsLogged(true);
        if (playerRole === EPlayerRole.ANIMATOR && name) {
            setAuthenticatedName(name);
            sessionStorage.setItem("authenticatedName", name);
        }
        // persist auth state
        sessionStorage.setItem("isLogged", "true");
        sessionStorage.setItem("token", code);
        sessionStorage.setItem("role", EPlayerRole[playerRole]);
        // If the player entered via a deep-link (non-root URL), redirect to root so
        // DefaultNavigation can read the real game state and route to the correct page.
        if (window.location.pathname !== "/" && sessionId) {
            const params = new URLSearchParams();
            params.set("sessionId", sessionId.toString());
            if (isAnimator)
                params.set("isAnimator", "true");
            else if (isCoAnimator)
                params.set("isCoAnimator", "true");
            window.location.href = `/?${params.toString()}`;
            return;
        }
    }
    function handleLogout() {
        sessionStorage.removeItem("isLogged");
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("role");
        sessionStorage.removeItem("authenticatedName");
        window.location.href = "/auth/logout";
    }
    // --------------------------------------------------------
    // STEP 5: Context value
    // --------------------------------------------------------
    const value = {
        isLogged,
        token,
        role,
        authenticatedName,
        isCoanimator: isCoAnimator,
        sessionId: sessionId !== null && sessionId !== void 0 ? sessionId : -1,
        onLoginSession: handleLogin,
    };
    // --------------------------------------------------------
    // STEP 6: Determine which page to show
    // --------------------------------------------------------
    let loginPage = null;
    if (!sessionId) {
        loginPage = (_jsx("div", Object.assign({ className: "absolute", style: {
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0,0,0,0.5)",
                zIndex: 10,
            } }, { children: _jsx("div", Object.assign({ className: "absolute", style: {
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                } }, { children: _jsx("h1", Object.assign({ className: "text-4xl text-white" }, { children: "Le lien est invalide, merci de contacter votre animateur" })) })) })));
    }
    else {
        loginPage = isAnimator ? (_jsx(AnimatorLoginPage, { onLogin: (token, name) => handleLogin(token, EPlayerRole.ANIMATOR, name) })) : (_jsx(PlayerLoginPage, { onLogin: (code) => handleLogin(code, isCoAnimator ? EPlayerRole.ANIMATOR : EPlayerRole.PLAYER, ""), sessionId: sessionId }));
    }
    // --------------------------------------------------------
    // STEP 7: Render
    // --------------------------------------------------------
    return (_jsxs(AuthContext.Provider, Object.assign({ value: value }, { children: [isLogged ? children : loginPage, role === EPlayerRole.ANIMATOR && (_jsx("div", Object.assign({ id: "logoutButton", className: "absolute hidden", style: { right: 10, bottom: 5, zIndex: 10 } }, { children: _jsx(FunctionalButton, { onClick: handleLogout, text: "Logout" }) })))] })));
};
export default AuthContextProvider;
